import SwitcherContainer from "../../../../../src/entities/UI/SwitcherContainer";
import { eventBus, EnumEventBus } from "../managers/EventBus";


const header = "Second Angle";
const handleFunc = (isActive: boolean) => eventBus.emit(EnumEventBus.showSecondAngles, isActive);
const coords = {
  horizontal: { x: 120, y: 250 },
  vertical: { x: 230, y: 630 }
}


export default class SecondAngleSwitcherCon extends SwitcherContainer {
  constructor() {
    super({ header, coords, handleFunc });
    eventBus.on(EnumEventBus.catMode, (v: boolean) => this.setActivation(v));
    eventBus.on(EnumEventBus.segmentMode, (v: boolean) => this.setActivation(v));
  }
}